var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 33.3213H31.7562",
    stroke: "#C7C7C7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33203 33.3213V2.33896L11.9681 1.32129V33.3213",
    stroke: "#C7C7C7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9688 1.32129L18.3009 5.50503V33.3213",
    stroke: "#C7C7C7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3008 10.8198L21.2407 10.0283V33.3216",
    stroke: "#C7C7C7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.2402 10.0283L25.9894 13.0813V33.3216",
    stroke: "#C7C7C7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 6.81952L13.002 4.46191V5.12247L17.0598 7.48008V6.81952Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 4.46191V3.16191L11.8779 2.50884V3.80884L13.002 4.46191ZM17.0598 6.81952L18.1839 7.47259V6.17259L17.0598 5.51952V6.81952ZM17.0598 7.48008V8.78008L18.1839 9.43315V8.13315L17.0598 7.48008ZM13.002 5.12247L11.8779 4.4694V5.7694L13.002 6.42247V5.12247ZM13.002 5.76191L17.0598 8.11952V5.51952L13.002 3.16191V5.76191ZM15.9358 6.16645V6.82701L18.1839 8.13315V7.47259L15.9358 6.16645ZM17.0598 6.18008L13.002 3.82247V6.42247L17.0598 8.78008V6.18008ZM14.126 5.77555V5.11498L11.8779 3.80884V4.4694L14.126 5.77555Z",
    fill: "#C7C7C7",
    mask: "url(#path-6-inside-1_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 9.84003L13.002 7.48242V8.14298L17.0598 10.5006V9.84003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 7.48242V6.18242L11.8779 5.52935V6.82935L13.002 7.48242ZM17.0598 9.84003L18.1839 10.4931V9.1931L17.0598 8.54003V9.84003ZM17.0598 10.5006V11.8006L18.1839 12.4537V11.1537L17.0598 10.5006ZM13.002 8.14298L11.8779 7.48991V8.78991L13.002 9.44298V8.14298ZM13.002 8.78242L17.0598 11.14V8.54003L13.002 6.18242V8.78242ZM15.9358 9.18696V9.84752L18.1839 11.1537V10.4931L15.9358 9.18696ZM17.0598 9.20059L13.002 6.84298V9.44298L17.0598 11.8006V9.20059ZM14.126 8.79605V8.13549L11.8779 6.82935V7.48991L14.126 8.79605Z",
    fill: "#C7C7C7",
    mask: "url(#path-8-inside-2_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-3_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 12.8596L13.002 10.502V11.1625L17.0598 13.5201V12.8596Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 10.502V9.20195L11.8779 8.54888V9.84888L13.002 10.502ZM17.0598 12.8596L18.1839 13.5126V12.2126L17.0598 11.5596V12.8596ZM17.0598 13.5201V14.8201L18.1839 15.4732V14.1732L17.0598 13.5201ZM13.002 11.1625L11.8779 10.5094V11.8094L13.002 12.4625V11.1625ZM13.002 11.802L17.0598 14.1596V11.5596L13.002 9.20195V11.802ZM15.9358 12.2065V12.867L18.1839 14.1732V13.5126L15.9358 12.2065ZM17.0598 12.2201L13.002 9.86251V12.4625L17.0598 14.8201V12.2201ZM14.126 11.8156V11.155L11.8779 9.84888V10.5094L14.126 11.8156Z",
    fill: "#C7C7C7",
    mask: "url(#path-10-inside-3_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-4_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 15.8801L13.002 13.5225V14.183L17.0598 16.5406V15.8801Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 13.5225V12.2225L11.8779 11.5694V12.8694L13.002 13.5225ZM17.0598 15.8801L18.1839 16.5331V15.2331L17.0598 14.5801V15.8801ZM17.0598 16.5406V17.8406L18.1839 18.4937V17.1937L17.0598 16.5406ZM13.002 14.183L11.8779 13.53V14.83L13.002 15.483V14.183ZM13.002 14.8225L17.0598 17.1801V14.5801L13.002 12.2225V14.8225ZM15.9358 15.227V15.8876L18.1839 17.1937V16.5331L15.9358 15.227ZM17.0598 15.2406L13.002 12.883V15.483L17.0598 17.8406V15.2406ZM14.126 14.8361V14.1755L11.8779 12.8694V13.53L14.126 14.8361Z",
    fill: "#C7C7C7",
    mask: "url(#path-12-inside-4_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-5_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 18.8996L13.002 16.542V17.2026L17.0598 19.5602V18.8996Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 16.542V15.242L11.8779 14.5889V15.8889L13.002 16.542ZM17.0598 18.8996L18.1839 19.5527V18.2527L17.0598 17.5996V18.8996ZM17.0598 19.5602V20.8602L18.1839 21.5132V20.2132L17.0598 19.5602ZM13.002 17.2026L11.8779 16.5495V17.8495L13.002 18.5026V17.2026ZM13.002 17.842L17.0598 20.1996V17.5996L13.002 15.242V17.842ZM15.9358 18.2465V18.9071L18.1839 20.2132V19.5527L15.9358 18.2465ZM17.0598 18.2602L13.002 15.9026V18.5026L17.0598 20.8602V18.2602ZM14.126 17.8556V17.1951L11.8779 15.8889V16.5495L14.126 17.8556Z",
    fill: "#C7C7C7",
    mask: "url(#path-14-inside-5_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-6_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 21.9191L13.002 19.5615V20.2221L17.0598 22.5797V21.9191Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 19.5615V18.2615L11.8779 17.6085V18.9085L13.002 19.5615ZM17.0598 21.9191L18.1839 22.5722V21.2722L17.0598 20.6191V21.9191ZM17.0598 22.5797V23.8797L18.1839 24.5328V23.2328L17.0598 22.5797ZM13.002 20.2221L11.8779 19.569V20.869L13.002 21.5221V20.2221ZM13.002 20.8615L17.0598 23.2191V20.6191L13.002 18.2615V20.8615ZM15.9358 21.2661V21.9266L18.1839 23.2328V22.5722L15.9358 21.2661ZM17.0598 21.2797L13.002 18.9221V21.5221L17.0598 23.8797V21.2797ZM14.126 20.8752V20.2146L11.8779 18.9085V19.569L14.126 20.8752Z",
    fill: "#C7C7C7",
    mask: "url(#path-16-inside-6_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-7_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 24.9396L13.002 22.582V23.2426L17.0598 25.6002V24.9396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 22.582V21.282L11.8779 20.629V21.929L13.002 22.582ZM17.0598 24.9396L18.1839 25.5927V24.2927L17.0598 23.6396V24.9396ZM17.0598 25.6002V26.9002L18.1839 27.5533V26.2533L17.0598 25.6002ZM13.002 23.2426L11.8779 22.5895V23.8895L13.002 24.5426V23.2426ZM13.002 23.882L17.0598 26.2396V23.6396L13.002 21.282V23.882ZM15.9358 24.2866V24.9471L18.1839 26.2533V25.5927L15.9358 24.2866ZM17.0598 24.3002L13.002 21.9426V24.5426L17.0598 26.9002V24.3002ZM14.126 23.8957V23.2351L11.8779 21.929V22.5895L14.126 23.8957Z",
    fill: "#C7C7C7",
    mask: "url(#path-18-inside-7_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-8_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 27.9592L13.002 25.6016V26.2621L17.0598 28.6197V27.9592Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 25.6016V24.3016L11.8779 23.6485V24.9485L13.002 25.6016ZM17.0598 27.9592L18.1839 28.6122V27.3122L17.0598 26.6592V27.9592ZM17.0598 28.6197V29.9197L18.1839 30.5728V29.2728L17.0598 28.6197ZM13.002 26.2621L11.8779 25.6091V26.9091L13.002 27.5621V26.2621ZM13.002 26.9016L17.0598 29.2592V26.6592L13.002 24.3016V26.9016ZM15.9358 27.3061V27.9667L18.1839 29.2728V28.6122L15.9358 27.3061ZM17.0598 27.3197L13.002 24.9621V27.5621L17.0598 29.9197V27.3197ZM14.126 26.9152V26.2546L11.8779 24.9485V25.6091L14.126 26.9152Z",
    fill: "#C7C7C7",
    mask: "url(#path-20-inside-8_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-9_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0598 30.9797L13.002 28.6221V29.2826L17.0598 31.6402V30.9797Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 28.6221V27.3221L11.8779 26.669V27.969L13.002 28.6221ZM17.0598 30.9797L18.1839 31.6327V30.3327L17.0598 29.6797V30.9797ZM17.0598 31.6402V32.9402L18.1839 33.5933V32.2933L17.0598 31.6402ZM13.002 29.2826L11.8779 28.6296V29.9296L13.002 30.5826V29.2826ZM13.002 29.9221L17.0598 32.2797V29.6797L13.002 27.3221V29.9221ZM15.9358 30.3266V30.9872L18.1839 32.2933V31.6327L15.9358 30.3266ZM17.0598 30.3402L13.002 27.9826V30.5826L17.0598 32.9402V30.3402ZM14.126 29.9357V29.2751L11.8779 27.969V28.6296L14.126 29.9357Z",
    fill: "#C7C7C7",
    mask: "url(#path-22-inside-9_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-10_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 14.307L22.1426 12.1807V12.7764L25.0833 14.9027V14.307Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 12.1807V10.8807L21.0891 10.1189V11.4189L22.1426 12.1807ZM25.0833 14.307L26.1367 15.0687V13.7687L25.0833 13.007V14.307ZM25.0833 14.9027V16.2027L26.1367 16.9645V15.6645L25.0833 14.9027ZM22.1426 12.7764L21.0891 12.0147V13.3147L22.1426 14.0764V12.7764ZM22.1426 13.4807L25.0833 15.607V13.007L22.1426 10.8807V13.4807ZM24.0298 13.5453V14.141L26.1367 15.6645V15.0687L24.0298 13.5453ZM25.0833 13.6027L22.1426 11.4764V14.0764L25.0833 16.2027V13.6027ZM23.196 13.5381V12.9424L21.0891 11.4189V12.0147L23.196 13.5381Z",
    fill: "#C7C7C7",
    mask: "url(#path-24-inside-10_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-11_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 17.0306L22.1426 14.9043V15.5001L25.0833 17.6264V17.0306Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 14.9043V13.6043L21.0891 12.8426V14.1426L22.1426 14.9043ZM25.0833 17.0306L26.1367 17.7923V16.4923L25.0833 15.7306V17.0306ZM25.0833 17.6264V18.9264L26.1367 19.6881V18.3881L25.0833 17.6264ZM22.1426 15.5001L21.0891 14.7383V16.0383L22.1426 16.8001V15.5001ZM22.1426 16.2043L25.0833 18.3306V15.7306L22.1426 13.6043V16.2043ZM24.0298 16.2689V16.8647L26.1367 18.3881V17.7923L24.0298 16.2689ZM25.0833 16.3264L22.1426 14.2001V16.8001L25.0833 18.9264V16.3264ZM23.196 16.2618V15.666L21.0891 14.1426V14.7383L23.196 16.2618Z",
    fill: "#C7C7C7",
    mask: "url(#path-26-inside-11_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-12_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 19.7543L22.1426 17.6279V18.2237L25.0833 20.35V19.7543Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 17.6279V16.3279L21.0891 15.5662V16.8662L22.1426 17.6279ZM25.0833 19.7543L26.1367 20.516V19.216L25.0833 18.4543V19.7543ZM25.0833 20.35V21.65L26.1367 22.4117V21.1117L25.0833 20.35ZM22.1426 18.2237L21.0891 17.462V18.762L22.1426 19.5237V18.2237ZM22.1426 18.9279L25.0833 21.0543V18.4543L22.1426 16.3279V18.9279ZM24.0298 18.9925V19.5883L26.1367 21.1117V20.516L24.0298 18.9925ZM25.0833 19.05L22.1426 16.9237V19.5237L25.0833 21.65V19.05ZM23.196 18.9854V18.3897L21.0891 16.8662V17.462L23.196 18.9854Z",
    fill: "#C7C7C7",
    mask: "url(#path-28-inside-12_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-13_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 22.4779L22.1426 20.3516V20.9473L25.0833 23.0736V22.4779Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 20.3516V19.0516L21.0891 18.2898V19.5898L22.1426 20.3516ZM25.0833 22.4779L26.1367 23.2396V21.9396L25.0833 21.1779V22.4779ZM25.0833 23.0736V24.3736L26.1367 25.1354V23.8354L25.0833 23.0736ZM22.1426 20.9473L21.0891 20.1856V21.4856L22.1426 22.2473V20.9473ZM22.1426 21.6516L25.0833 23.7779V21.1779L22.1426 19.0516V21.6516ZM24.0298 21.7162V22.3119L26.1367 23.8354V23.2396L24.0298 21.7162ZM25.0833 21.7736L22.1426 19.6473V22.2473L25.0833 24.3736V21.7736ZM23.196 21.709V21.1133L21.0891 19.5898V20.1856L23.196 21.709Z",
    fill: "#C7C7C7",
    mask: "url(#path-30-inside-13_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-14_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 25.2015L22.1426 23.0752V23.671L25.0833 25.7973V25.2015Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 23.0752V21.7752L21.0891 21.0135V22.3135L22.1426 23.0752ZM25.0833 25.2015L26.1367 25.9632V24.6632L25.0833 23.9015V25.2015ZM25.0833 25.7973V27.0973L26.1367 27.859V26.559L25.0833 25.7973ZM22.1426 23.671L21.0891 22.9092V24.2092L22.1426 24.971V23.671ZM22.1426 24.3752L25.0833 26.5015V23.9015L22.1426 21.7752V24.3752ZM24.0298 24.4398V25.0355L26.1367 26.559V25.9632L24.0298 24.4398ZM25.0833 24.4973L22.1426 22.371V24.971L25.0833 27.0973V24.4973ZM23.196 24.4327V23.8369L21.0891 22.3135V22.9092L23.196 24.4327Z",
    fill: "#C7C7C7",
    mask: "url(#path-32-inside-14_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-15_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 27.9252L22.1426 25.7988V26.3946L25.0833 28.5209V27.9252Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 25.7988V24.4988L21.0891 23.7371V25.0371L22.1426 25.7988ZM25.0833 27.9252L26.1367 28.6869V27.3869L25.0833 26.6252V27.9252ZM25.0833 28.5209V29.8209L26.1367 30.5826V29.2826L25.0833 28.5209ZM22.1426 26.3946L21.0891 25.6329V26.9329L22.1426 27.6946V26.3946ZM22.1426 27.0988L25.0833 29.2252V26.6252L22.1426 24.4988V27.0988ZM24.0298 27.1634V27.7592L26.1367 29.2826V28.6869L24.0298 27.1634ZM25.0833 27.2209L22.1426 25.0946V27.6946L25.0833 29.8209V27.2209ZM23.196 27.1563V26.5606L21.0891 25.0371V25.6329L23.196 27.1563Z",
    fill: "#C7C7C7",
    mask: "url(#path-34-inside-15_3386_11376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-16_3386_11376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 30.6488L22.1426 28.5225V29.1182L25.0833 31.2445V30.6488Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 28.5225V27.2225L21.0891 26.4607V27.7607L22.1426 28.5225ZM25.0833 30.6488L26.1367 31.4105V30.1105L25.0833 29.3488V30.6488ZM25.0833 31.2445V32.5445L26.1367 33.3063V32.0063L25.0833 31.2445ZM22.1426 29.1182L21.0891 28.3565V29.6565L22.1426 30.4182V29.1182ZM22.1426 29.8225L25.0833 31.9488V29.3488L22.1426 27.2225V29.8225ZM24.0298 29.8871V30.4828L26.1367 32.0063V31.4105L24.0298 29.8871ZM25.0833 29.9445L22.1426 27.8182V30.4182L25.0833 32.5445V29.9445ZM23.196 29.8799V29.2842L21.0891 27.7607V28.3565L23.196 29.8799Z",
    fill: "#C7C7C7",
    mask: "url(#path-36-inside-16_3386_11376)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessBuilding);
export default __webpack_public_path__ + "static/media/BusinessBuilding.9d796b3c6fdff743e3996b3d98592eca.svg";
export { ForwardRef as ReactComponent };